module.exports = __webpack_public_path__ + "img/signinbackground.d0a3601f.png";